import { tv } from "@kirvanobr/theme";

export const styles = tv({
  slots: {
    base: "max-w-[520px] p-6 gap-4",
    backdrop: "dark:bg-foreground/5",
  },
});
